const TEST_VARIATION_A = 'test_variation_a';
const TEST_VARIATION_B = 'test_variation_b';
const TEST_VARIATION_C = 'test_variation_c';

const getTestVariation = (abTests, testNumber) => {
    const variation = abTests[testNumber];

    if (typeof variation === 'undefined' || variation === '0' || variation === '1') {
        return TEST_VARIATION_A;
    } else if (variation === '2') {
        return TEST_VARIATION_B;
    } else {
        return TEST_VARIATION_C;
    }
};

const inAbTest = (abTests, testNumber) => {
    const variation = getTestVariation(abTests, testNumber);

    return variation === TEST_VARIATION_B;
};

module.exports = {
    TEST_VARIATION_A,
    TEST_VARIATION_B,
    TEST_VARIATION_C,
    getTestVariation,
    inAbTest
};
